import script from "./ProjectBonAppetit.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectBonAppetit.vue?vue&type=script&setup=true&lang=js"

import "./ProjectBonAppetit.vue?vue&type=style&index=0&id=b67dd3fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b67dd3fa"]])

export default __exports__